import script from "./AppBannerExtended.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBannerExtended.vue?vue&type=script&setup=true&lang=js"

import "./AppBannerExtended.vue?vue&type=style&index=0&id=c0ed10ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ed10ac"]])

export default __exports__